import api from "./api";

class PatientDoctorRelatedService {
  getDoctor(serviceID) {
    return api.get(`/api/patient/relateddoctor/service/${serviceID}`);
  }
}

export default new PatientDoctorRelatedService();
